export default __webpack_public_path__ + "655fb44.png";